import { Dialog, DialogContent } from "@/components/ui";
import { Payment } from "@/containers/profile/payment";

export const CreditCardScreenModal = ({
  open,
  onClose,
}: {
  open: boolean;
  onClose: () => void;
}) => {
  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="h-full max-w-none overflow-scroll md:max-h-[720px] md:max-w-lg">
        <Payment />
      </DialogContent>
    </Dialog>
  );
};
